import { render, staticRenderFns } from "./CalendarWidget.vue?vue&type=template&id=0c506d22&scoped=true"
import script from "./CalendarWidget.vue?vue&type=script&lang=js"
export * from "./CalendarWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c506d22",
  null
  
)

export default component.exports